import { h } from 'preact';
import ExpandIcon from '../utils/icons/expand.svg';

const SpecificationLink = ({ specificationsLength, setIsOpen }) => {
  const anchorVisibility = specificationsLength !== 0 ? '' : 'hidden ';
  const handleViewClick = (e) => {
    e.preventDefault();
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };
  document.addEventListener('flyout:open', handleViewClick);
  return (
    <div className="col-span-12">
      <a
        href="#"
        className={`${anchorVisibility}flex min-w-fit 
                    relative py-4 px-5 border border-grey-400 justify-between items-center`}
        onClick={handleViewClick}
      >
        <span className="font-b-12 uppercase">View Specifications</span>
        <ExpandIcon />
      </a>
    </div>
  );
};

export default SpecificationLink;
